<template>

        <conteudo :ajax="false">
                
                <h1 class='f3'> {{ $t('Planejamento') }}  </h1>

                 <!-- <div class="form-group">
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>1</b>  {{ $t('Selecione a Prova') }} </label>

                    <div class='step-content'>
                        <race-selector>
                        </race-selector>
                    </div>
                </div>


                -->

                <div class="form-group">
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>1</b>  {{ $t('Adicione seus corredores') }} </label>

                    <div class='step-content'>


                            <div class="input-group">
                                <input  v-model="runnerName" @keyup.enter.prevent="addCorredor" name="corredor" autocomplete="false" class="form-control" id="prependedInput" type="text" placeholder="Digite o nome do corredor">
                                <div class="input-group-append">
                                    <button @click="addCorredor"  class="btn btn-outline-secondary" type="button">Adicionar</button>
                                </div>
                            </div>


                            <ul id="corredores-list">
                                <li v-for="(corredor,index) in corredores" :style="{color:corredor.color}" :key="corredor.id" >
                                   <span class="name dib w-70"> {{ corredor.name }} </span> <span  class="distance dib w-20 white"> {{ getDistance(corredor.id)}} </span> <i @click="remove(corredor.id)" class="fa fa-times"></i>
                                </li>
                            </ul>
                    
                    </div>
                </div>

                <div class="form-group" >
                    <label class="step o-40" for="exampleFormControlSelect1"> <b>2</b>  {{ $t('Selecione o trecho') }} </label>

                    <div class='step-content ph2' v-if="corredores.length > 0">

                        <div v-for="(trecho,index) in checkpoints" class="trecho-linha row trecho-planejamento align-items-center" :style="{backgroundColor:getRunnerColor(trecho.properties.numero)}" >

                                <div class="col-12 col-md-7 tl trecho-nome">
                                    <b> {{ $t('Trecho') }} {{index+1}} </b>  <small class="o-50"> &emsp;{{trecho.properties.distance.toFixed(2)}}  km</small> 
                                </div>
                                
                                <div class="col-12 col-md-5 ">

                                    <b-dropdown size="sm" class="dropdownrunner m-md-2" :style="{backgroundColor:getRunnerColor(trecho.properties.numero)}" 
                                                            :text="getRunnerName(trecho.properties.numero)" 
                                                            >
                                    
                                        <b-dropdown-item @click.prevent="setTrechoRunner(trecho.properties.numero,false)" >  ---  </b-dropdown-item>
                                        <b-dropdown-item v-for="(corredor,i) in corredores" @click.prevent="setTrechoRunner(trecho.properties.numero,corredor.id)">
                                            <span :style="{color:corredor.color}" > {{corredor.name}}</span>
                                        </b-dropdown-item>
                                 
                                    </b-dropdown>

                                </div>

                        </div>
                    
                    </div>
                </div>


                

                




            

        </conteudo>

</template>


<script>
    import Conteudo from './conteudo.vue'

    export default {
        data(){
            return {
                mudando:false,
                runners:[],
                runnerName:"",
             


            }
        },

        components: {
            'conteudo':Conteudo
        },

        computed:{
            checkpoints:function(){
                return this.$store.getters.checkpointsCourses;
            },
            
            currentRace:function(){
                return this.$store.getters.currentRace;
            },

            corredores:function(){
                return this.$store.getters.corredores;
            },
            corredoresByID:function(){
                return _.keyBy(this.corredores, 'id');
            },
            trechoRunners:function(){
                return this.$store.getters.trechoRunner;
            },
            trechoRunnersByTrecho:function(){
                return _.keyBy(this.trechoRunners, 'trechoID');
            },
            trechosRunnerObject:function(){
                return this.$store.getters.trechosRunnersObject;
            },

        },

        watch:{
            '$route':function(to,from){
                    var id = _.get(to,'params.id',0);
                    this.$store.commit('trechoIndex',id);
                    vtl.mapBase.percurso.showTrecho(id);
            }
        },

        mounted(){
            this.$store.commit('openPlanejamento',true)

        },
        beforeDestroy:function(){
             this.$store.commit('openPlanejamento',false)

        },


        methods:{

            addCorredor:function(){
                    var runnerName = this.runnerName.toUpperCase();
                    debugger;
                    if( !_.isEmpty(runnerName) && (this.corredores.length < 8) ){
                        this.$store.commit('addRunner',runnerName);
                        this.runnerName = "";
                    }
            },

            remove:function(id){
                  this.$store.commit('removeRunner',id);
            },



            setTrechoRunner:function(trechoID,runnerID){

                // var trechoObj = {
                //     numero:trecho.properties.numero,
                //     distance: trecho.properties.distance
                // }

                debugger;
                this.$store.commit('addTrechoToRunner',{trechoID,runnerID});
            },



            getRunnerName:function(trechoID){
                debugger;
                var name="---Selecione---";
                var trechoRunner = this.trechoRunnersByTrecho[trechoID];
                if(trechoRunner){
                    name = _.get(this.corredoresByID[trechoRunner.runnerID],'name',name)
                }
                return name;
            },

            getRunnerColor:function(trechoID){
                
                var color="rgba(255,255,255,0.2)";
                var trechoRunner = this.trechoRunnersByTrecho[trechoID];
                if(trechoRunner){
                    color = _.get(this.corredoresByID[trechoRunner.runnerID],'color',color)
                }
                return color;
            },

            getDistance(runnerID){
                var distance = 0;
                _.each(this.trechosRunnerObject,item=>{
                    if(item.runner.id==runnerID){
                        distance += item.trecho.properties.distance
                    }
                })

                return distance.toFixed(2)+ " kms"
            }
          


        }


    }
    
</script>





<style lang="stylus" scoped>
    @import "./../css/variaveis"

    .trecho-info{

            .descripition{
                    b,strong{
                        color lighten(color-orange,40%)
                    }
            }

    }
    
       
        .slide-enter-to, .slide-leave{ 
               transform: translateX(10px);
               opacity: 0.5;
                transition: all .6s ease;
        }
         .slide-enter, .slide-leave-to{
               transform: translateX(10px);
               opacity: 0;
               transition: all .6s ease;
        }


    .navegationTrechos{

        a{
            cursor: pointer;
            display:inline-block;
            background rgba(black,0.5);
            padding:1em 2em;
        }
        
    }


    .info{
        font-size:12px;
        font-weight bolder;
        margin-left:2em;
        }


    #corredores-list{
        padding:0;

        li{
            list-style none;
            padding: 0.75em 1em;
            text-transform uppercase;
            font-weight bolder;
            // border-bottom:1px solid rgba(white,0.2)
            margin-bottom:1px;
            background rgba(white,0.1);
            position:relative;

            .fa-times{
                cursor:pointer;
                position:absolute;
                right:0.5em;
                opacity:0;
                transition: 200ms opacity;
            }
            &:hover .fa-times{
                 opacity:1;
            }
        }
    }

    .trecho-planejamento.row{
            
            margin-bottom:1px;

            .trecho-nome{
                color:white !important;
                opacity:1 !important;
            }
    
    }

  .dropdownrunner{

        button.btn.dropdown-toggle{
                background-color: inherit !important;
                border-color:none !important;;
                outline:none !important;
                width 100%;
        }
    }

</style>